import script from "./ManagementPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementPage.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementPage.vue?vue&type=style&index=0&id=1a0e6c3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0e6c3c"]])

export default __exports__